import { Grid } from '@material-ui/core';
import { Typography } from '@nutrien/cxp-components';
import React from 'react';

import type { EtapFieldInfo } from '../../rxdb/assetDetails/assetDetails.types';
import { EtapPropertiesLabel } from '../../utilities/enums';
import { useWindowDimensions } from '../../utilities/useWindowDimensions';
import useStyles from './EtapProperties.styles';

interface Props {
  etapFields: EtapFieldInfo;
}

const EtapProperties: React.FC<Props> = ({ etapFields }) => {
  const size = useWindowDimensions();
  const classes = useStyles({ size });
  const firstColumnLabels = [
    {
      name: EtapPropertiesLabel.ETAP_ID,
      value: etapFields?.etapAssetId || '-',
    },
    {
      name: EtapPropertiesLabel.WORKING_DISTANCE,
      value: etapFields?.workingDistance || '-',
    },
    {
      name: EtapPropertiesLabel.TOTAL_ENERGY,
      value: etapFields?.totalEnergy || '-',
    },
  ];

  const secondColumnLabels = [
    {
      name: EtapPropertiesLabel.KV,
      value: etapFields?.kv || '-',
    },
    {
      name: EtapPropertiesLabel.AFB,
      value: etapFields?.afb || '-',
    },
  ];

  const getLabelsAndValue = (label: { name: string; value: string | number }) => {
    return (
      <Grid item container xs={12} className={classes.entityGrid}>
        <Grid item xs={12} className={classes.flexRow}>
          <Grid item xs={6}>
            <Typography
              variant="subtitle1"
              color="textSecondary"
              fontWeight="normal"
              className={classes.labelStyle}
            >
              {label.name}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1" fontWeight="normal" className={classes.staticValues}>
              {label.value}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Grid className={`${classes.card} ${classes.dynamicProp1}`}>
        <Typography variant="h5" className={classes.otherPropText}>
          ETAP Properties
        </Typography>
      </Grid>
      <Grid xs={12} className={classes.mainGrid}>
        <Grid xs={12} className={classes.flexColumn}>
          {firstColumnLabels.map(label => getLabelsAndValue(label))}
        </Grid>
        <Grid xs={12} className={classes.flexColumn}>
          {secondColumnLabels.map(label => getLabelsAndValue(label))}
        </Grid>
      </Grid>
    </>
  );
};

export default EtapProperties;
